<template>
	<Icon v-bind="$props">
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 388 512"
			class="icon-file-excel"
		>
			<path
				opacity=".4"
				class="duotone"
				d="M249.4 0l0 110.7c0 15.3 12.4 27.7 27.7 27.7l110.7 0L318.5 69.2 249.4 0z"
			/>
			<path
				class="duotone"
				d="M.3 27.7C.3 12.4 12.7 0 27.9 0L249.4 0l0 110.7c0 15.3 12.4 27.7 27.7 27.7l110.7 0 0 345.9c0 15.3-12.4 27.7-27.7 27.7L27.9 512C12.7 512 .3 499.6 .3 484.3L.3 27.7zM54.5 191.6c0 7.6 6.2 13.8 13.8 13.8l81.6 0c7.6 0 13.8-6.2 13.8-13.8s-6.2-13.8-13.8-13.8l-81.6 0c-7.6 0-13.8 6.2-13.8 13.8zM95.9 372.9L54.7 434.3l30.7 0L113.3 387 142 434.3l32.5 0-42.5-61.9 38-55.6-31.4 0-24.1 41.2L89.5 316.7l-32.5 0 38.9 56.1zM68.3 246.1c-7.6 0-13.8 6.2-13.8 13.8s6.2 13.8 13.8 13.8l81.6 0c7.6 0 13.8-6.2 13.8-13.8s-6.2-13.8-13.8-13.8l-81.6 0zm122.2-54.5c0 7.6 6.2 13.8 13.8 13.8l40.8 0c7.6 0 13.8-6.2 13.8-13.8s-6.2-13.8-13.8-13.8l-40.8 0c-7.6 0-13.8 6.2-13.8 13.8zm13.8 54.5c-7.6 0-13.8 6.2-13.8 13.8s6.2 13.8 13.8 13.8l40.8 0c7.6 0 13.8-6.2 13.8-13.8s-6.2-13.8-13.8-13.8l-40.8 0z"
			/>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from '../Icon'
export default {
	name: 'ExcelIcon',
	components: { Icon },
	props,
}
</script>
<style scoped>
svg path {
	fill: #29b37e !important;
}
</style>
